const BG = {
  ibanLength: 22,
};
export { BG };
